import { EInvoiceTvaType } from "../e-invoice-tva";

export class EInvoiceDiscountDto {
  AmountHt: number;
  AmountTtc: number;
  Percent: number;
  TvaAmount: number;
  TvaPercent: number;
  TvaType: EInvoiceTvaType;
}
